import type { ItemCacheLockId } from '../store/schema/ItemCacheLockId';
import type { ItemCache } from '../store/schema/ItemCache';
import type { CacheDescriptor } from '../store/schema/CacheDescriptor';
import { checkContainsDescriptorForLock } from './checkContainsDescriptorForLock';

export function lockHasDescriptor<T, U extends CacheDescriptor>(
    store: ItemCache<T, U>,
    lockId: ItemCacheLockId,
    itemDescriptor: U,
    containsDescriptor: (descriptor1: U, descriptor2: U) => boolean
): boolean {
    const lockDescriptorIds = store.locks.get(lockId);
    if (!lockDescriptorIds) {
        return false;
    }
    return (
        lockDescriptorIds.some(lockedDescriptorId => lockedDescriptorId === itemDescriptor.Id) ||
        checkContainsDescriptorForLock(store, lockId, itemDescriptor, containsDescriptor)
    );
}
